import { render } from "./BaseFooter.vue?vue&type=template&id=18fd10b8&scoped=true"
const script = {}

import "./BaseFooter.vue?vue&type=style&index=0&id=18fd10b8&lang=scss&scoped=true"

import exportComponent from "/Users/hpy/monetware/项目/product-home-html/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-18fd10b8"]])

export default __exports__